export const siteConfig = {
  name: 'SimplerDevelopment',
  description:
    'The all-in-one business platform with a brain: 19 integrated tools — websites, CRM, email, booking, projects and an AI that runs them for you.',
  url: 'https://simplerdevelopment.com',
  ogImage: 'https://simplerdevelopment.com/og.jpg',
  links: {
    twitter: 'https://twitter.com/simplerdevelopment',
    github: 'https://github.com/SimplerDevelopment/SimplerDevelopment',
    linkedin: 'https://linkedin.com/company/simplerdevelopment',
  },
  keywords: [
    'all-in-one business platform',
    'AI business software',
    'CRM and website builder',
    'business automation platform',
    'small business SaaS',
    'AI-native platform',
    'website CRM email booking',
    'company brain AI',
  ],
};

export type SiteConfig = typeof siteConfig;
